import {
  GetDataTable_dataTable,
  GetDataTable_dataTable_rows,
  GetDataTable_dataTable_rows_containerRows,
  GetDataTable_dataTable_rows_containerRows_containerRows,
  GetDataTable_dataTable_rows_innerTableRows,
} from '../../services/types/GetDataTable';

export const getAllRows = (
  dataTable: GetDataTable_dataTable,
): Array<
  | GetDataTable_dataTable_rows
  | GetDataTable_dataTable_rows_innerTableRows
  | GetDataTable_dataTable_rows_containerRows
  | GetDataTable_dataTable_rows_containerRows_containerRows
> => {
  return dataTable.rows.flatMap((row) => [
    row,
    ...(row.innerTableRows ?? []),
    ...(row.containerRows?.flatMap((containerRow) => [
      containerRow,
      ...(containerRow.innerTableRows ?? []),
      ...(containerRow.containerRows?.flatMap((containerRow2) => [
        containerRow2,
        ...(containerRow2.innerTableRows ?? []),
      ]) ?? []),
    ]) ?? []),
  ]);
};
